import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const VenmoBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.VENMO}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.VENMO)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.VENMO)} alt="venmo" />
    </Box>
  );
};
